import { EDUCATION_TYPE_LIST } from './educationType';

export const FilterEnumAnswers = {
  gender: {
    label: 'Пол',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Мужской'
      },
      {
        id: 2,
        value: 'Женский'
      }
    ]
  },
  refund_enrollment_status: {
    label: 'Был ли зачислен возврат',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Да'
      },
      {
        id: 2,
        value: 'Нет'
      },
      {
        id: 3,
        value: ''
      }
    ]
  },
  refund_status: {
    label: 'Статус возврата',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'В обработке'
      },
      {
        id: 2,
        value: 'Средства возвращены'
      },
      {
        id: 3,
        value: 'Нет'
      }
    ]
  },
  transfer_status: {
    label: 'Статус переноса',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'В обработке'
      },
      {
        id: 2,
        value: 'Средства перенесены'
      },
      {
        id: 3,
        value: 'Нет'
      }
    ]
  },
  RF_location: {
    label: 'Нахождение в РФ',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Да'
      },
      {
        id: 2,
        value: 'Нет'
      }
    ]
  },
  started_learning: {
    label: 'Приступил к обучению',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Да'
      },
      {
        id: 2,
        value: 'Нет'
      }
    ]
  },
  form_study: {
    label: 'Форма обучения',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Очная'
      },
      {
        id: 2,
        value: 'Гибрид'
      },
      {
        id: 3,
        value: 'Онлайн'
      }
    ]
  },
  education_type: {
    label: 'Тип обучения',
    type: 'string',
    answers: EDUCATION_TYPE_LIST.map((value, index) => ({ id: index + 1, value }))
  },
  enrollment: {
    label: 'Статус зачисления',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Зачислен'
      },
      {
        id: 2,
        value: 'Не зачислен'
      },
      {
        id: 3,
        value: 'Отчислен'
      },
      {
        id: 4,
        value: 'Восстановлен'
      }
    ]
  },
  payment_status: {
    label: 'Статус оплаты',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Оплачено'
      },
      {
        id: 2,
        value: 'Не оплачено'
      },
      {
        id: 3,
        value: 'Оплачено частично'
      }
    ]
  },
  scholarship: {
    label: 'Стипендия',
    type: 'string',
    answers: [
      {
        id: 1,
        value: 'Да'
      },
      {
        id: 2,
        value: 'Нет'
      }
    ]
  }
};
